export const getCardinalDirection = (degrees) => {
	if( degrees >= 45 && degrees < 135 ) {
		return 'N';
	}
	if( degrees >= 135 && degrees < 225 ) {
		return 'W';
	}
	if( degrees >= 225 && degrees < 315 ) {
		return 'S';
	}
	return 'E';
}